<template>
  <div id="fault-map-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px; position: relative">
      <div class="d-flex justify-start mb-3">
        <span class="font-weight-bold text-h5 my-auto mr-4" style="height: 40px;">故障モード例図解</span>
        <div>
          <v-select
              label="種類選択"
              v-show="editMode"
              @change="changedFaultMap"
              outlined
              hide-details
              dense
              v-model="selectedMap"
              :items="maps"
          ></v-select>
        </div>
      </div>
      <v-img
          contain
          eager
          lazy-src="@/assets/images/no-image.png"
          max-height="922px"
          :src="selectedMap ? mapUrls[selectedMap] : ''"
      >
        <template v-slot:placeholder>
          <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
          >
            <v-progress-circular
                v-if="selectedMap"
                :size="70"
                :width="7"
                indeterminate
                color="grey lighten-5"
            ></v-progress-circular>
            <v-icon
                v-if="!selectedMap"
                x-large
                color="red darken-1"
            >
              mdi-alert
            </v-icon>
          </v-row>
        </template>
      </v-img>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span
            class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{ naviVisibleList.findIndex(item => item.text === '故障モード解説') + 2 }}/{{ naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";

export default {
  name: "FaultMapPage",
  props: ['naviVisibleList', 'cropImagePageNum', 'editMode', 'report', 'printMode', 'pdfPageNum'],
  data(){
    return {
      maps: [
        {
          text: 'Full cell',
          value: 'full_cell',
        },
        {
          text: 'Half cut cell (triple bypass)',
          value: 'half_cut_cell_triple',
        },
        {
          text: 'Half cut cell (dual bypass)',
          value: 'half_cut_cell_dual',
        },
        {
          text: 'Performance',
          value: 'performance',
        }
      ],
      selectedMap: 'full_cell',
      mapUrls: {
        'full_cell': require("@/assets/images/full_cell.png"),
        'half_cut_cell_triple': require("@/assets/images/half_cut_cell_triple.png"),
        'half_cut_cell_dual': require("@/assets/images/half_cut_cell_dual.png"),
        'performance': require("@/assets/images/performance.png")
      },
      folderUuid : this.$route.params.folderUuid,
    }
  },
  methods: {
    changedFaultMap(){
      this.axios
          .put('/api/report/update/faultmap/' + this.folderUuid, {faultmap: this.selectedMap})
          .then(() => {
            this.report.faultMap = this.selectedMap;
          })
          .catch(() => {
            store.showErrorDialog('故障モード例図解の保存にてエラーが発生しました。再度試してください。');
          })
    }
  },
  created() {
    if (this.report.faultMap){
      this.selectedMap = this.report.faultMap;
    }
    else {
      this.report.faultMap = 'full_cell';
    }
  }
}
</script>

<style scoped>
>>>.v-text-field .v-select__slot .v-select__selection--comma{
  min-width: min-content
}
</style>
